var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-app"},[_c('edit-photo-modal',{attrs:{"show":_vm.showEditPhotoModal,"photoType":_vm.editPhotoType},on:{"close":function($event){_vm.showEditPhotoModal = false},"uploadDone":_vm.uploadDone}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56299c24","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/profile/TheProfile.vue
// module id = 190
// module chunks = 4